import { useState, useCallback } from 'react';

/**
 * Hook to manage all dialog states in a consolidated way
 * Reduces boilerplate and makes dialog management more maintainable
 */
export function useDialogState() {
  const [dialogs, setDialogs] = useState({
    createAssignment: false,
    completeAssignment: false,
    deleteEvent: false,
    createNote: false,
    eventAction: false,
    editEvent: false,
    settings: false
  });

  const [formState, setFormState] = useState({
    newAssignmentDesc: '',
    noteText: '',
    selectedAssignment: null,
    eventToDelete: null,
    selectedEvent: null,
    editDescription: ''
  });

  /**
   * Open a specific dialog
   */
  const openDialog = useCallback((dialogName) => {
    setDialogs(prev => ({ ...prev, [dialogName]: true }));
  }, []);

  /**
   * Close a specific dialog
   */
  const closeDialog = useCallback((dialogName) => {
    setDialogs(prev => ({ ...prev, [dialogName]: false }));
  }, []);

  /**
   * Update form state
   */
  const updateForm = useCallback((field, value) => {
    setFormState(prev => ({ ...prev, [field]: value }));
  }, []);

  /**
   * Reset a form field
   */
  const resetForm = useCallback((field) => {
    setFormState(prev => ({
      ...prev,
      [field]: typeof prev[field] === 'string' ? '' : null
    }));
  }, []);

  /**
   * Close dialog and reset associated form fields
   */
  const closeAndResetDialog = useCallback((dialogName, ...formFields) => {
    closeDialog(dialogName);
    formFields.forEach(field => resetForm(field));
  }, [closeDialog, resetForm]);

  return {
    dialogs,
    formState,
    openDialog,
    closeDialog,
    updateForm,
    resetForm,
    closeAndResetDialog
  };
}
